import { LdapUsersResponse } from '@spo/types';
import { apiBff } from '.';

export const getUsersByIds = async (
  userIds: string[],
): Promise<LdapUsersResponse> =>
  apiBff.callBFF('POST', 'ldap/users', { userIds });
